import React from 'react';
import ProductsPage from './ProductsPage';

// Legacy Products layout kept for reference and review
const ProductsOldPage = () => {
  return <ProductsPage />;
};

export default ProductsOldPage;
